import { setDoc } from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { asUserId, err, ok, permissionDenied, } from "@pack-it-up/shared";
import { observeDoc, patchField, toDomainError } from "./support.js";
// The owner's own private profile doc (users/{uid} — Doc 02 §8, Doc 04 §6). Changes to
// displayName/photoUrl are fanned out to the denormalised friend copies and trip member
// entries by the `onUserProfileWrite` Firestore trigger (functions/src/profile.ts), so
// the client only ever writes its own doc.
export const makeUserProfileRepo = (db, p, session, auth) => ({
    observeMyProfile: (userId) => observeDoc(p.user(userId), (raw) => {
        const d = raw;
        return ok({
            userId: asUserId(userId),
            displayName: d.displayName ?? "",
            email: d.email ?? "",
            ...(d.photoUrl !== undefined ? { photoUrl: d.photoUrl } : {}),
        });
    }, "userProfile"),
    observeMySettings: (userId) => observeDoc(p.user(userId), (raw) => {
        const d = raw;
        return ok({
            timezone: d.timezone ?? "UTC",
            reminderSendHour: d.reminderSendHour ?? 7,
            defaultStagingOptIn: d.defaultStagingOptIn ?? false,
            itemDisplay: d.itemDisplay ?? "condensed",
        });
    }, "userSettings"),
    writeProfile: async (patch) => {
        const me = session.user();
        if (me === null)
            return err(permissionDenied("update your profile"));
        const data = {};
        patchField(data, "displayName", patch.displayName);
        patchField(data, "photoUrl", patch.photoUrl);
        patchField(data, "timezone", patch.timezone);
        patchField(data, "reminderSendHour", patch.reminderSendHour);
        patchField(data, "defaultStagingOptIn", patch.defaultStagingOptIn);
        patchField(data, "itemDisplay", patch.itemDisplay);
        if (Object.keys(data).length === 0)
            return ok(undefined);
        try {
            await setDoc(p.user(me.id), data, { merge: true });
            // Keep the Auth record in step with the profile doc, so AuthUser.displayName
            // (read from Firebase Auth on the next sign-in) doesn't drift.
            const current = auth.currentUser;
            if (current !== null && (patch.displayName !== undefined || patch.photoUrl !== undefined)) {
                await updateProfile(current, {
                    ...(patch.displayName !== undefined ? { displayName: patch.displayName } : {}),
                    // Auth rejects a null photoURL; the empty string is its "cleared" value.
                    ...(patch.photoUrl !== undefined ? { photoURL: patch.photoUrl ?? "" } : {}),
                });
            }
            return ok(undefined);
        }
        catch (e) {
            return err(toDomainError(e));
        }
    },
});
//# sourceMappingURL=userProfile.repo.js.map